routes.$inject = ['$stateProvider'];

var templateWorkflowUrl = require('./templates/workflow.html');
var templateHmrUrl = require('./templates/hmr.html');
var templateHmrReportUrl = require('./templates/report.html');

export default function routes($stateProvider) {
  $stateProvider
    .state('app.hmrworkflow', {
      url: '/dashboard',
      templateUrl: templateWorkflowUrl,
      controller: 'WorkflowController',
      controllerAs: 'workflowCtrl'
    })
    .state('app.hmr', {
      url: '/referral/{hmr_external_id:[A-Z]*\\d+}',
      templateUrl: templateHmrUrl,
      controller: 'HmrController',
      controllerAs: 'hmrCtrl',
      params: {
        hmr_external_id: null,
        bodyClasses: 'cases'
      }
    })
    .state('app.report', {
      url: "/referral/{hmr_external_id:[A-Z]*\\d+}/report",
      templateUrl: templateHmrReportUrl,
      controller: 'HmrController',
      controllerAs: 'hmrCtrl',
      params: {
        hmr_external_id: null,
        bodyClasses: 'cases'
      }
    })
  ;
}



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/features/referral/hmr.routes.js
 **/